import * as React from 'react'

const SvgTagGroupIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 10a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM10 18.75a.625.625 0 01-.444-.181L2.87 11.875a1.25 1.25 0 01-.369-.881V6.25C2.5 5.56 3.06 5 3.75 5h4.744c.33.001.648.134.881.369l6.694 6.687a.625.625 0 010 .888l-5.625 5.625a.625.625 0 01-.444.181zM3.75 6.25v4.744l6.25 6.25 4.744-4.744-6.25-6.25H3.75zm13.569 2.056L10.625 1.62a1.25 1.25 0 00-.881-.369H5c-.69 0-1.25.56-1.25 1.25v1.25H5V2.5h4.744l6.25 6.25-.813.806.888.888 1.25-1.25a.625.625 0 000-.888z"
      fill="#163250"
    />
  </svg>
)

export default SvgTagGroupIcon
